import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

type PageCTAProps = {
  children: ReactNode;
  className?: string;
};

function PageCTA({ children, className }: PageCTAProps) {
  return (
    <div
      data-cta='true'
      className={cn(
        'mt-auto lg:mt-0 flex flex-col gap-4',
        'bg-background pt-4 pb-safe',
        'lg:bg-transparent lg:pt-0 lg:pb-0',
        className,
      )}
    >
      {children}
    </div>
  );
}

export default PageCTA;
